import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type PinIconProps = IconProps;

export const PinIcon: FC<PinIconProps> = ({ iconColor = '#344054', className, ...props }) => {
  return (
    <svg
      className={twMerge('shrink-0', className)}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99964 10.0002L7.99964 14.6668M5.33297 4.87225V6.29266C5.33297 6.43134 5.33297 6.50068 5.31936 6.567C5.30728 6.62585 5.28731 6.68279 5.25998 6.73628C5.22918 6.79657 5.18586 6.85072 5.09923 6.959L4.05271 8.26715C3.60888 8.82194 3.38697 9.09933 3.38672 9.33278C3.3865 9.5358 3.47881 9.72787 3.63748 9.85452C3.81994 10.0002 4.17517 10.0002 4.88564 10.0002H11.1136C11.8241 10.0002 12.1793 10.0002 12.3618 9.85452C12.5205 9.72787 12.6128 9.5358 12.6126 9.33278C12.6123 9.09933 12.3904 8.82194 11.9466 8.26715L10.9 6.959C10.8134 6.85071 10.7701 6.79657 10.7393 6.73628C10.712 6.68279 10.692 6.62585 10.6799 6.567C10.6663 6.50068 10.6663 6.43134 10.6663 6.29266V4.87225C10.6663 4.7955 10.6663 4.75713 10.6706 4.71928C10.6745 4.68566 10.6809 4.65239 10.6898 4.61974C10.6998 4.58299 10.7141 4.54736 10.7426 4.4761L11.4145 2.79631C11.6105 2.30625 11.7085 2.06123 11.6677 1.86453C11.6319 1.69252 11.5297 1.54157 11.3833 1.4445C11.2158 1.3335 10.9519 1.3335 10.4241 1.3335H5.57514C5.04733 1.3335 4.78342 1.3335 4.61597 1.4445C4.46954 1.54157 4.36734 1.69252 4.3316 1.86453C4.29073 2.06123 4.38874 2.30625 4.58476 2.79631L5.25668 4.4761C5.28518 4.54736 5.29943 4.58299 5.30946 4.61974C5.31837 4.65239 5.32478 4.68566 5.32863 4.71928C5.33297 4.75713 5.33297 4.7955 5.33297 4.87225Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
    </svg>
  );
};
